import React from "react"
import { Link } from "@tanstack/react-router"
import { ShieldCheck, Lock, Truck, Activity } from "lucide-react"

export function AuthLeftPanel() {
  return (
    <aside className="w-full lg:w-1/2 flex flex-col justify-center px-8 sm:px-12 md:px-20 lg:px-24 text-white bg-[#1a1a1a] relative overflow-hidden p-8 shrink-0 min-h-[320px] lg:h-screen">
      <div className="relative z-10 max-w-sm mx-auto md:mx-0">
        {/* Brand Logo */}
        <Link to="/" className="flex items-baseline mb-2 font-sans text-3xl md:text-4xl font-black select-none tracking-tight text-white hover:text-white/95">
          <span className="text-primary">E</span>
          <span>NGA</span>
        </Link>
        
        {/* Tagline */}
        <p className="text-lg text-slate-300 mb-8 font-medium">
          Procurement, simplified.
        </p>
        
        {/* Benefits List */}
        <ul className="flex flex-col gap-4">
          <li className="flex items-center gap-3">
            <ShieldCheck className="size-5 text-primary shrink-0" />
            <span className="text-sm font-medium">Verified global sellers</span>
          </li>
          <li className="flex items-center gap-3">
            <Lock className="size-5 text-primary shrink-0" />
            <span className="text-sm font-medium">Admin-mediated privacy</span>
          </li>
          <li className="flex items-center gap-3">
            <Truck className="size-5 text-primary shrink-0" />
            <span className="text-sm font-medium">Integrated logistics</span>
          </li>
          <li className="flex items-center gap-3">
            <Activity className="size-5 text-primary shrink-0" />
            <span className="text-sm font-medium">Real-time RFQ tracking</span>
          </li>
        </ul>
      </div>
    </aside>
  )
}
